export const texts = {
  es: {
    stepperTitle: "Términos y condiciones",
    title: "Aceptación de términos y condiciones",
    acceptButton: "Aceptar",
    acceptButtonTooltip:
      "Es necesario leer y desplazarte en el documento para activar este botón",
    backButton: "Volver",
    outline: {
      title: "Documentos",
      currentDocument: "Sin aceptar",
      acceptedDocument: "Aceptado",
      pendingDocument: "Pendiente",
    },
    personalInformation: {
      title: "Tus datos",
      name: "Nombre completo",
      email: "Mail",
      country: "País de residencia",
      referral: "Referido",
    },
  },
  en: {
    stepperTitle: "Terms and conditions",
    title: "Terms and conditions acceptance",
    acceptButton: "Accept",
    acceptButtonTooltip:
      "You must read and scroll this document for this button to activate",
    backButton: "Back",
    outline: {
      title: "Documents",
      currentDocument: "Not yet accepted",
      acceptedDocument: "Accepted",
      pendingDocument: "Pending",
    },
    personalInformation: {
      title: "Your data",
      name: "Full name",
      email: "Email",
      country: "Country of residence",
      referral: "Referral",
    },
  },
};